import { Interval } from "date-fns";

import ActivityStatusOption from "@mapmycustomers/shared/enum/activity/ActivityStatusOption";
import PlatformFilterOperator from "@mapmycustomers/shared/enum/PlatformFilterOperator";
import { Condition } from "@mapmycustomers/shared/types/viewModel/platformModel/PlatformFilterModel";

const getStartRange = (
  recapInterval: Interval | undefined,
  filter: ActivityStatusOption
): Condition | undefined => {
  if (filter === ActivityStatusOption.NOT_SCHEDULED) {
    return {
      [PlatformFilterOperator.EQUALS]: null,
    };
  }

  const now = new Date();

  if (filter === ActivityStatusOption.OVERDUE) {
    const intervalEnd = recapInterval ? new Date(recapInterval.end) : undefined;
    const upper = intervalEnd && intervalEnd < now ? intervalEnd : now;
    return {
      ...(recapInterval && {
        [PlatformFilterOperator.GREATER_THAN_OR_EQUAL]: new Date(recapInterval.start).toISOString(),
      }),
      [PlatformFilterOperator.LESS_THAN]: upper.toISOString(),
    };
  }

  if (filter === ActivityStatusOption.UPCOMING) {
    const intervalStart = recapInterval ? new Date(recapInterval.start) : undefined;
    const lower = intervalStart && intervalStart > now ? intervalStart : now;
    return {
      [PlatformFilterOperator.GREATER_THAN_OR_EQUAL]: lower.toISOString(),
      ...(recapInterval && {
        [PlatformFilterOperator.LESS_THAN]: new Date(recapInterval.end).toISOString(),
      }),
    };
  }

  if (recapInterval) {
    return {
      [PlatformFilterOperator.GREATER_THAN_OR_EQUAL]: new Date(recapInterval.start).toISOString(),
      [PlatformFilterOperator.LESS_THAN]: new Date(recapInterval.end).toISOString(),
    };
  }
};

export default getStartRange;
